"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewBar = void 0;
exports.viewBar = {
    youAreViewing: "You are viewing:",
    exit: "Exit",
};
